/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProformaJiraIssueFormsDirectEmbedType from '@jira/spa-apps__proforma-issue-forms-direct-embed/src/ProformaIssueFormsDirectEmbedProformaJiraIssueFormsDirectEmbedWrapper.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProformaIssueFormsDirectEmbed: LazyComponent<() => React.JSX.Element | null> =
	lazyForPaint<typeof ProformaJiraIssueFormsDirectEmbedType>(
		() =>
			import(
				/* webpackChunkName: "async-proforma-issue-forms-direct-embed", jiraSpaEntry: "async-proforma-issue-forms-direct-embed" */ '@jira/spa-apps__proforma-issue-forms-direct-embed/src/ProformaJiraIssueFormsDirectEmbedWrapper.tsx'
			),
	);

const AsyncProformaIssueFormsDirectEmbed = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProformaIssueFormsDirectEmbed}
		pageId="proforma-issue-forms-direct-embed"
		shouldShowSpinner
	/>
);

export default AsyncProformaIssueFormsDirectEmbed;
